import { UserDetailFromJSON, UserDetailToJSON, } from './UserDetail';
/**
 * Check if a given object implements the GetUserDetailResponse interface.
 */
export function instanceOfGetUserDetailResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
export function GetUserDetailResponseFromJSON(json) {
    return GetUserDetailResponseFromJSONTyped(json, false);
}
export function GetUserDetailResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': UserDetailFromJSON(json['user']),
    };
}
export function GetUserDetailResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': UserDetailToJSON(value.user),
    };
}
